export interface ExxactMachineStatus {
  speed: number;
  steering_angle_target: number;
  gps_fix_status: number;
  battery_voltage: number;
  engine_speed: number;
  four_wheel_steering_active: boolean;
  fuel_percentage: number;
  steering_mode: SteeringMode;
}

export interface SteeringMode {
  mode: SteeringModeStatus;
}

export enum SteeringModeStatus {
  FrontWheel = 0,
  FourWheel = 1,
  Crab = 2
}

// Converts JSON strings to/from your types
export class ConvertMachineStatus {
  public static toMachineStatus(json: string): ExxactMachineStatus {
    return JSON.parse(json);
  }

  public static machineStatusToJson(value: ExxactMachineStatus): string {
    return JSON.stringify(value);
  }
}
